import { render, staticRenderFns } from "./CusPaymentsTablePage.vue?vue&type=template&id=618c3ee8&scoped=true"
import script from "./CusPaymentsTablePage.vue?vue&type=script&lang=js"
export * from "./CusPaymentsTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c3ee8",
  null
  
)

export default component.exports